import { IconPropsType } from '..';

interface SwitchThumbOnIconProps extends IconPropsType {
  pathFill?: string;
}

export const SwitchThumbOnIcon = ({ className, pathFill, ...props }: SwitchThumbOnIconProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <rect
      width="18"
      height="18"
      rx="9"
    />
    <path
      d="M13.2426 4.80005L7.7272 10.6545L4.75735 7.34563L3.48456 8.61843L7.7272 13.2L14.5154 6.07284L13.2426 4.80005Z"
      fill={pathFill}
    />
  </svg>
);
